import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { searchApi } from '@services'

export const getDataTopVote = createAsyncThunk(
  'vote/getDataTopVote',
  async () => {
    const response = await searchApi.getTopVote()
    return response.data.ranks || []
  }
)

const initialState = {
  topVotes: [] as any,
  isLoading: false
}

const voteSlice = createSlice({
  name: 'vote',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.isLoading = action.payload
    }
  },
  extraReducers: builder => {
    builder.addCase(getDataTopVote.fulfilled, (state, action) => {
      state.topVotes = action.payload
    })
  }
})

export const {
  setLoading
} = voteSlice.actions

export default voteSlice.reducer
